import { Outlet } from '@remix-run/react';

export default function NewsPage() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
